<template>
  <div class="message-container">
    <Message 
      v-if="account != null"
      :account="route.params.account"
      :auto_read="account.auto_read"
      :folder="null"
      :message_uuid="route.params.message"
      :message_type="null"
      :message_index="-1"
      :standalone="true"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import * as accountService from '@/services/account.service.js';
import Message from '@/components/Message.vue';

const route = useRoute();

const account = ref(null);

async function init() {
  account.value = accountService.get(route.params.account);
}

init();
</script>

<style scoped>
.message-container {
  max-width: 120ch;
  margin-inline: auto;
}
</style>
